import { Config } from '../config';
import { EventsFilter, Fleet, Permit, RoadworksOutput } from '../interfaces';
import { setRoadworkQueryCache } from '../queries';
import { EventsService } from './events.service';
import { HttpService } from './http.service';

const pathV2 = `${Config.APIv2}/roadworks/permits`;

export abstract class RoadworksService {
  public static getRoadworkPermits = (
    filter: EventsFilter,
    fleet: Fleet,
    abortSignal?: AbortSignal,
  ): Promise<RoadworksOutput> => {
    const filters = EventsService.sanitizeFilters(filter, fleet.timezone ?? 'America/New_York');
    // Adjust the fields shape so that they're more to the backends' liking
    const newFilters = { ...filters, date_from: filters.dateFrom, date_to: filters.dateTo };
    return HttpService.fetchAuthorized(
      // This endpoint ignores limit in body and default user fleet
      `${pathV2}/query?limit=1000&fleet_id=${fleet.uuid}`,
      {
        method: 'POST',
        body: JSON.stringify({ ...newFilters }),
      },
      abortSignal,
    ).then((res: RoadworksOutput) => {
      if (res === null || !Array.isArray(res.permits)) {
        return { permits: [] };
      }

      res?.permits?.forEach((e) => {
        setRoadworkQueryCache(e);
      });

      return res.permits ? res : { permits: [] };
    });
  };

  public static getRoadworkPermit = (id: string): Promise<Permit | null> => {
    return HttpService.fetchAuthorized(`${pathV2}/${id}`).then((res: Permit | null) => {
      return res;
    });
  };

  public static postRoadworkPermitsDefinition = (file: File): Promise<any> => {
    const formData = new FormData();
    formData.append('file', file);

    return HttpService.fetchAuthorized(`${pathV2}`, {
      method: 'POST',
      body: formData,
    }).then((res) => res);
  };
}
